import clsx from "clsx";

type Props = {
  children: React.ReactNode;
  disabled?: boolean;
};

export const SBCCard = ({ children, disabled }: Props) => {
  return (
    <article
      className={clsx(
        "w-full desktop:min-h-[320px] h-full p-4 relative bg-panel-background hover:bg-panel-middleground rounded-lg group",
        disabled && " cursor-default pointer-events-none",
      )}
    >
      {children}
    </article>
  );
};
